import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import CaseStudyCard from '../../Components/CaseStudyCard';
import caseStudies  from '../../data/CaseStudiesData/caseStudies';

const CaseStudies = () => {

   useEffect(() => {
    AOS.init();
  }, []);


  return (
    <section className="lg:py-28 lg:px-12 px-5  py-28 bg-[#121212] text-white ">
      <div className='container xl:mx-auto xl:max-w-screen-xl'  data-aos="fade-up">
      <h2 className="text-heading-4 lg:text-heading-1 font-dmsans font-bold tracking-[-0.06em] mb-8 ">
        Case Studies That <br className="hidden sm:block" /> 
        <span className="">Speak for Themselves</span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-y-11 lg:gap-x-4">
        {caseStudies.map((caseStudy, index) => (
            <CaseStudyCard
              key={index}
              image={caseStudy.image}
              title={caseStudy.title}
              tags={caseStudy.tags}
               link={caseStudy.link}
               alt={caseStudy.alt}
               
            />
          ))}
      </div>
      </div>
    </section>
  );
};

export default CaseStudies;
